import { ArrowRightOutlined, UserOutlined } from '@ant-design/icons';
import { useOrderChanges } from '@hooks';
import { L } from '@lib';
import { ServiceOrderStatusTag } from '@models';
import { Order } from '@services';
import { serviceOrderChangeDateParser } from '@utils';
import { Avatar, Col, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import { observer } from 'mobx-react';

const { Text } = Typography;

interface IProps {
  order: Order;
}

export const OrderChangeShared: React.FC<IProps> = observer(({ order }) => {
  const { orderChanges } = useOrderChanges(order);
  return (
    <>
      {orderChanges.map((orderChange) => {
        const fromRange = serviceOrderChangeDateParser(orderChange.from);
        const toRange = serviceOrderChangeDateParser(orderChange.to);
        const creationTime = dayjs.utc(orderChange.creationTime);
        const creationLocal = creationTime.local().format('MMMM DD, YYYY h:mm A');

        return (
          <Row key={orderChange.id}>
            <Col span={24}>
              <Row gutter={8}>
                <Col>
                  <Avatar style={{ background: '#0891B2' }} icon={<UserOutlined />} />
                </Col>
                <Col>
                  <b>{orderChange.user.fullname}</b> changed the <b>{orderChange.type}</b>{' '}
                  {creationLocal}
                </Col>
              </Row>
            </Col>
            <Col offset={2} style={{ marginTop: -5, marginBottom: 10 }}>
              {orderChange.type === 'Workstation' ? (
                <Row gutter={4}>
                  <Col>
                    {orderChange.from ? (
                      <Text>{orderChange.from}</Text>
                    ) : (
                      <Text>{L('Unassigned')}</Text>
                    )}
                  </Col>
                  <Col>
                    <ArrowRightOutlined />
                  </Col>
                  <Col>
                    {orderChange.to ? (
                      <Text>{orderChange.to}</Text>
                    ) : (
                      <Text>{L('Unassigned')}</Text>
                    )}
                  </Col>
                </Row>
              ) : orderChange.type === 'Status' ? (
                <Row gutter={4}>
                  <Col>{ServiceOrderStatusTag[orderChange.from as never]}</Col>
                  <Col style={{ marginLeft: -6 }}>
                    <ArrowRightOutlined />
                  </Col>
                  <Col>{ServiceOrderStatusTag[orderChange.to as never]}</Col>
                </Row>
              ) : orderChange.type === 'Technician' ? (
                <Row gutter={4}>
                  <Col>
                    {orderChange.from ? (
                      <Text>{orderChange.from}</Text>
                    ) : (
                      <Text>{L('Unassigned')}</Text>
                    )}
                  </Col>
                  <Col>
                    <ArrowRightOutlined />
                  </Col>
                  <Col>
                    {orderChange.to ? (
                      <Text>{orderChange.to}</Text>
                    ) : (
                      <Text>{L('Unassigned')}</Text>
                    )}
                  </Col>
                </Row>
              ) : orderChange.type === 'Date' ? (
                <Row gutter={4}>
                  <Col>
                    <Text>{fromRange ? fromRange : L('Unassigned')}</Text>
                  </Col>
                  <Col>
                    <ArrowRightOutlined />
                  </Col>
                  <Col>
                    <Text>{toRange ? toRange : L('Unassigned')}</Text>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </Col>
            <br />
          </Row>
        );
      })}
    </>
  );
});
